import { LocalNotifications } from "@capacitor/local-notifications"
import { Capacitor } from "@capacitor/core"

export const GV_NOTIFICATION_SOUND = "notification_sound.wav"

// Unique IDs for each meal type
const mealTypeToId = {
	breakfast: 100,
	lunch: 101,
	dinner: 102,
	snack: 103,
	// Add more meal types as needed
}

export async function bloodSugarNotif(mealType, delay, mealTime) {
	if (!mealTypeToId[mealType.toLowerCase()]) return

	const channelId = "GV"
	const sound = GV_NOTIFICATION_SOUND
	if (Capacitor.isNativePlatform()) {
		//see if channel already exists
		const channels = await LocalNotifications.listChannels()
		// console.log("The channels", JSON.stringify(channels.channels))

		//delete all the channels
		// if (channels.channels.length > 0) {
		// 	for (const channel of channels.channels)
		// 		await LocalNotifications.deleteChannel({
		// 			id: channel.id,
		// 		})
		// }

		//does gvChannel exist?
		const gvChannel = channels.channels.find(
			(channel) => channel.id === channelId
		)
		//no? create it
		if (!gvChannel) {
			await LocalNotifications.createChannel({
				id: channelId,
				name: "Grub Vision",
				description: "Helpful notifications from Grub Vision.",
				importance: 5,
				visibility: 1,
				vibration: true,
				lights: true,
				sound,
			})
		}
	}

	console.log("Scheduling notification...")
	try {
		// Check notification permissions
		const permissionStatus = await LocalNotifications.checkPermissions()
		let hasPermission = permissionStatus.display === "granted"

		if (!hasPermission) {
			const requestResult = await LocalNotifications.requestPermissions()
			hasPermission = requestResult.display === "granted"
			if (!hasPermission) {
				console.warn("User denied notification permissions.")
				// Skip scheduling if permission is not granted
			}
		}

		if (hasPermission) {
			const mt = new Date(mealTime)
			// Use user's preferred delay, default to 2 hours if not set
			//const delayInMinutes = userStore.user?.bloodSugarNotificationDelay ?? 120
			const delayInMinutes = delay ?? 120
			const delayInMs = delayInMinutes * 60 * 1000 // Convert hours to milliseconds
			const triggerTime = new Date(mt.getTime() + delayInMs)
			const now = new Date()

			if (triggerTime > now) {
				// Check for existing notifications to avoid duplicates
				const pending = await LocalNotifications.getPending()

				//temp cancel all pending
				// if (pending.notifications.length > 0)
				// 	await LocalNotifications.cancel({
				// 		notifications: pending.notifications,
				// 	})

				const isAlreadyScheduled = pending.notifications.some(
					(n) => n.id === mealTypeToId[mealType]
				)

				if (!isAlreadyScheduled) {
					await LocalNotifications.schedule({
						notifications: [
							{
								id: mealTypeToId[mealType],
								title: "Blood Sugar Reminder",
								body: `[${mealType.toLowerCase()}] Time to take your blood sugar.`,
								schedule: {
									at: triggerTime,
									allowWhileIdle: true, // Fires even when device is idle
								},
								channelId,
								// sound,
							},
						],
					})
					console.log(
						`Notification scheduled for ${mealType} at ${triggerTime}`
					)
				} else {
					console.log(
						`Notification for ${mealType} already scheduled; skipping.`
					)
				}
			} else {
				console.warn("Trigger time is in the past; notification not scheduled.")
			}
		}
	} catch (error) {
		console.error("Error handling notifications:", error)
	}
}
